import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { CreateProviderDepartmentAutoTextPausesMutationDocument } from '@docpace/manager-graphql/dist/urql.types'
import { CreateProviderDepartmentAutoTextPausesMutationResultFragment } from '@docpace/manager-graphql'

const typedCreateProviderDepartmentAutoTextPausesMutationDocument = CreateProviderDepartmentAutoTextPausesMutationDocument as TypedDocumentNode<CreateProviderDepartmentAutoTextPausesMutationResultFragment>

export function useCreateProviderDepartmentAutoTextPausesMutation(opts?: useMutation.Options<CreateProviderDepartmentAutoTextPausesMutationResultFragment>){
    return useMutation(typedCreateProviderDepartmentAutoTextPausesMutationDocument, opts)
}
